import React, { ReactElement } from 'react';

interface Props {
  className?: string;
}

function cancel({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      stroke="black"
      width="24"
      height="24"
      className={className}
    >
      <path
        fill="none"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M18 6L6 18M6 6l12 12"
      ></path>
    </svg>
  );
}

export default cancel;
